export const RIGHT_SIDEBAR_ACTIONS = {
  SET_OPTION: 'RIGHT_SIDEBAR/SET_OPTION',
  SET_SEARCH: 'RIGHT_SIDEBAR/SET_SEARCH',
  SET_BACK_OPTION: 'SET_BACK_OPTION',
}
